/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RoomCapability {
    Undefined = 0,
    Training = 1,
    Debriefing = 2,
    Control = 4,
    DigitalSignage = 8,
    NonSimulation = 16,
    TrainTheTrainer = 32,
}
